<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jfx10s/tc-custom/9780226149486.jpg?1722580550319" alt="This image is the cover for the book Mircea Eliade: Autobiography"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mircea Eliade: Autobiography
      </h1>
      <p class="bookDescription body article font2">
        <p>"Here finally are Eliade's memoirs of the first thirty years of his life in Mac Linscott Rickett's crisp and lucid English translation. They present a fascinating account of the early development of a Renaissance talent, expressed in everything from daily and periodical journalism, realistic and fantastic fiction, and general nonfiction works to distinguished contributions to the history of religions. Autobiography follows an apparently amazingly candid report of this remarkable man's progression from a mischievous street urchin and literary prodigy, through his various love affairs, a decisive and traumatic Indian sojourn, and active, brilliant participation in pre-World War II Romanian cultural life."—Seymour Cain, <i>Religious Studies Review</i><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mircea Eliade
      </h2>
      
      <p class="authorDescription body article"><B>Mircea Eliade</B> (1907-1986) was the Sewell L. Avery Distinguished Service Professor in the Divinty School and professor in the Committee on Social Thought at the University of Chicago. In 1985 the trustees of the University established the Mircea Eliade Chair in the History of Religions in his honor. His many books include novels, short stories, and plays as well as works in the history of religion, most notably the <I>Encyclopedia of Religions</I> and <I>A History of Religious Ideas</I>.<br></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2ed8db06